var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8945_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 23C13.9895 23 15.8971 22.2098 17.3036 20.8033C18.7102 19.3968 19.5003 17.4891 19.5003 15.5C19.5003 14.634 19.2703 13.803 19.0003 13.03C17.3333 14.677 16.0673 15.5 15.2003 15.5C19.1953 8.5 17.0003 5.5 11.0003 1.5C11.5003 6.5 8.20434 8.774 6.86234 10.037C5.76766 11.0667 5.00757 12.4015 4.68062 13.8683C4.35367 15.3352 4.47493 16.8664 5.02868 18.2635C5.58244 19.6606 6.54315 20.8592 7.78624 21.7037C9.02934 22.5483 10.4975 22.9999 12.0003 23ZM12.7103 5.235C15.9513 7.985 15.9673 10.122 13.4633 14.509C12.7023 15.842 13.6653 17.5 15.2003 17.5C15.8883 17.5 16.5843 17.3 17.3193 16.905C17.1015 17.728 16.6955 18.4892 16.1335 19.1286C15.5714 19.768 14.8686 20.2682 14.0804 20.5899C13.2922 20.9115 12.44 21.0458 11.5911 20.9821C10.7421 20.9184 9.91958 20.6585 9.18814 20.2229C8.45671 19.7873 7.83639 19.1878 7.37602 18.4717C6.91565 17.7556 6.62781 16.9424 6.53516 16.0961C6.4425 15.2498 6.54756 14.3936 6.84207 13.5948C7.13658 12.7961 7.61249 12.0766 8.23234 11.493C8.35834 11.375 8.99734 10.808 9.02534 10.783C9.44934 10.403 9.79834 10.066 10.1433 9.697C11.3733 8.379 12.2573 6.917 12.7093 5.235H12.7103Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8945_1611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeat);
export default __webpack_public_path__ + "static/media/heat.11a79bca9bb85890f576e1b431be6a07.svg";
export { ForwardRef as ReactComponent };